import React, { useState, useCallback, useRef, useEffect } from "react";
import Webcam from "react-webcam";
import { base64ToImage } from "../../utilis/common-funtions";
import FlipCameraIosIcon from '@mui/icons-material/FlipCameraIos';
const WebCamera = ({ handleFileChangeWebCamera }) => {
  const webcamRef = useRef(null);

  // const [imgSrc, setImgSrc] = React.useState(null);
  // const [capturedImage, setCapturedImage] = React.useState([]);
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const checkDevice = async () => {
      if (navigator.userAgentData) {
        const platform = navigator.userAgentData.platform || '';
        setIsDesktop(['Windows', 'macOS', 'Linux', 'Chrome OS'].includes(platform));
      } else {
        // Fallback for older browsers using userAgent
        const desktopRegex = /Windows|Macintosh|Linux|X11/;
        setIsDesktop(desktopRegex.test(navigator.userAgent));
      }
    };

    checkDevice();
  }, []);

  const [facingMode, setFacingMode] = useState(!isDesktop ? "environment" : "user");

  const capture = useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot();
    const img = base64ToImage(imageSrc);
    handleFileChangeWebCamera(img);
    // removeBlobImages();
    // setCapturedImage([img]);
  }, [webcamRef, handleFileChangeWebCamera]);

  const toggleCamera = () => {
    setFacingMode((prev) => (prev === "user" ? "environment" : "user"));
  };
   // useEffect(() => {
  
  //   return () => {
  //     // URL.revokeObjectURL(webcamRef.current)
  //     if(showCapturedImage)
  //     setShowCapturedImage(false)
  //   }
  // }, [])

  return (
    <>
      <Webcam
        audio={false}
        ref={webcamRef}
        screenshotFormat="image/jpeg"
        className="webcamCapture"
        videoConstraints={{ facingMode }}
      />
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        {!isDesktop && (
          <button onClick={toggleCamera} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '50px', marginTop: '5px', marginBottom:'0px' }} className="btnCapture">
            <FlipCameraIosIcon />
          </button>
        )}
        <button onClick={capture} className="btnCapture">
          Capture photo
        </button>
      </div>
    </>
  );
};

export default WebCamera;
